import React from 'react'
import styled from 'styled-components'
import Textarea from 'react-textarea-autosize'

import { placeholder, borderColor, inputBackground } from 'styles/colors'
import { title } from 'styles/texts'

const Input = styled(Textarea)`
  ${title};
  background: ${inputBackground};
  border: 1px solid ${borderColor};
  border-radius: 4px;
  padding: 10px 13px 11px;
  width: 100%;
  -webkit-appearance: none;

  &::placeholder {
    color: ${placeholder};
  }
  resize: none;
`

export default props => <Input minRows={5} {...props} />



// WEBPACK FOOTER //
// ./src/components/form/Textarea.js